import { Box, Modal } from "@mui/material";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./UnitCost.module.css";
import Button from "../../Subcomponents/Button";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
const useStyles = makeStyles((theme) => ({
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.2rem",
		top: "1.2rem",
	},
}));
const UnitCost = ({ open, handleClose, allotment }) => {
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const classes = useStyles();
	function closeModal() {
		handleClose();
	}

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Summary</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.priceBreakDown}>
						<div className={cssClasses.price}>
							<span className={cssClasses.priceText}>Agreement Value</span>
							<span>₹{numberWithCommas(allotment.unitCost?.bsp)}</span>
						</div>
						<div className={cssClasses.price}>
							<span className={cssClasses.priceText}>SDR </span>
							<span>₹{numberWithCommas(allotment.unitCost?.sdr)}</span>
						</div>
						<div className={cssClasses.price}>
							<span className={cssClasses.priceText}>GST </span>
							<span>₹{numberWithCommas(allotment.unitCost?.gst)}</span>
						</div>
						<div className={cssClasses.price}>
							<span className={cssClasses.priceText}>Unit Cost</span>
							<span>₹{numberWithCommas(allotment.unitCost?.total)}</span>
						</div>
					</div>
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div className={cssClasses.blockLabel} style={{ width: "100%", textAlign: "left", color: "red",fontSize:"1.4rem",fontStyle:"italic" }}>
					{allotment?.unitId?.wingId?.termsAndCondition && allotment?.unitId?.wingId?.termsAndCondition }
					</div>
					<div>
						<Button
							style={{
								color: "#fff",
								backgroundColor: "#1570EF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Close"}
							clicked={() => {
								closeModal();
							}}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default UnitCost;
